import { Modal } from "antd";
import React from "react";
import { TituloTabela } from "../../TipoTurma/styles/styled";
import TableReducao from "./TableReducao";

const ModalReducao = ({
  Registro,
  visibleReducao,
  setVisibleReducao,
  reducao
}) => {
  const Titulo = ({ texto }) => {
    return <TituloTabela style={{ marginTop: "25px" }}>{texto}</TituloTabela>;
  };

  const Capitalize = (str) => {
    if (str) {
      let arr = str?.toLowerCase().split(" ");

      for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
      }

      const str2 = arr?.join(" ");

      return str2;
    }
  };

  return (
    <Modal
      open={visibleReducao}
      destroyOnClose={true}
      closable={true}
      maskClosable={true}
      keyboard={false}
      width={"auto"}
      onCancel={() => setVisibleReducao("", false)}
      footer={""}
      height={200}
    >
      <Titulo
        texto={`Reduções de ${Capitalize(
          Registro?.nome
        )}`}
      />
      <TableReducao Registro={Registro} reducao={reducao} />
    </Modal>
  );
};

export default ModalReducao;
